module.exports = __webpack_public_path__ + "img/minus.ed43086c.svg";